import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-locale-date-time',
  template: require('./locale-date-time.component.html'),
  styles: [require('./locale-date-time.component.sass')]
})
export class LocaleDateTimeComponent implements OnInit, OnDestroy {

  @Input() datetime: string | number | Date;
  @Input() format: string;

  selectedLanguage: string;

  languageChangeSubscription: Subscription;

  constructor(
    private translate: TranslateService
  ) { 
    this.selectedLanguage = this.translate.currentLang;
   }

  ngOnInit(): void {
    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.selectedLanguage = this.translate.currentLang;
    })
  }

  ngOnDestroy() {
    if (this.languageChangeSubscription) {
      this.languageChangeSubscription.unsubscribe();
    }
  }
}
